import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Fingerprint } from "lucide-react";
import { NavLink } from "react-router-dom";
import { requestBrightSurface } from "../../hooks/useScreenBoost";
import { useNavItems } from "./useNavItems";

const NavSlot = ({ to, itemKey, icon: Icon, label }) => (
  <NavLink
    to={to}
    end={to === "/"}
    data-testid={`mnav-${itemKey}`}
    className={({ isActive }) =>
      `flex min-w-0 flex-col items-center justify-center gap-1 px-1 text-[10px] font-bold transition-colors duration-200 ${
        isActive ? "text-primary" : "text-muted-foreground"
      }`
    }
  >
    <Icon className="h-[1.5125rem] w-[1.5125rem] shrink-0" />
    <span className="w-full truncate text-center leading-tight">{label}</span>
  </NavLink>
);

export const BottomNav = () => {
  const { t } = useTranslation();
  const { bottom } = useNavItems();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const startCheck = () => {
    requestBrightSurface();
    if (pathname !== "/") navigate("/");
    setTimeout(() => window.dispatchEvent(new Event("helcoo:checkin")), pathname === "/" ? 0 : 350);
  };

  const left = bottom.slice(0, 2);
  const right = bottom.slice(2);

  return (
    <nav
      data-testid="mobile-nav"
      className="fixed inset-x-3 bottom-[max(0.75rem,env(safe-area-inset-bottom))] z-40 lg:hidden"
    >
      <div className="relative grid h-16 grid-cols-5 items-center rounded-full border border-border/50 bg-background/85 px-2 shadow-neu backdrop-blur-xl">
        {left.map((i) => (
          <NavSlot key={i.to} to={i.to} itemKey={i.key} icon={i.icon} label={t(`nav.${i.key}`)} />
        ))}
        {Array.from({ length: 2 - left.length }).map((_, i) => (
          <span key={`pad-start-${i}`} />
        ))}

        <div className="flex items-center justify-center">
          <button
            type="button"
            onClick={startCheck}
            data-testid="mnav-checkin-fab"
            aria-label={t("check.in")}
            className="absolute -top-7 flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full bg-primary text-primary-foreground shadow-[0_10px_24px_rgba(0,229,140,0.45)] transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            <Fingerprint className="h-11 w-11" strokeWidth={2.2} />
          </button>
        </div>

        {right.map((i) => (
          <NavSlot key={i.to} to={i.to} itemKey={i.key} icon={i.icon} label={t(`nav.${i.key}`)} />
        ))}
        {Array.from({ length: 2 - right.length }).map((_, i) => (
          <span key={`pad-end-${i}`} />
        ))}
      </div>
    </nav>
  );
};
